import { render, staticRenderFns } from "./arquivoCriacaoConta.vue?vue&type=template&id=88f11c72&scoped=true&"
import script from "./arquivoCriacaoConta.vue?vue&type=script&lang=js&"
export * from "./arquivoCriacaoConta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f11c72",
  null
  
)

export default component.exports